export default "__VITE_ASSET__113b1706__"